import "../../css/frontend/main.css";
import "./modules/header";
import "./modules/swiper";
import "./modules/shore-booking-button";
import "./modules/cookie-consent";
import "./modules/announcement";
import "./modules/fx";
